import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


interface BinProps extends StyledProps {
  color?: string;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const COEmissionsSVG: React.FunctionComponent<BinProps> = ({ ...rest }) => {
  return (
    <StyledContainer {...rest}>
      <svg width="19" height="15" fill="none" viewBox="0 0 19 15">
        <path
          fill="#070B16"
          d="M4.219 5.625c.29 0 .571.026.853.073.708-1.69 2.364-2.886 4.303-2.886a4.63 4.63 0 012.201.564c.271-.3.59-.542.926-.758A3.752 3.752 0 009.375.938c-.926 0-1.76.348-2.414.9A3.728 3.728 0 003.75 0 3.748 3.748 0 000 3.75c0 1.12.502 2.113 1.282 2.802a5.13 5.13 0 012.937-.927zm7.57-.973a3.72 3.72 0 00-2.414-.902c-1.515 0-2.81.902-3.401 2.191.457.167.896.396 1.292.689.852-.653 1.907-1.005 3.046-1.005 1.608 0 3.08.758 4.073 2.025.354-.097.717-.15 1.084-.15 1.04 0 1.981.392 2.717 1.018.353-.57.564-1.235.564-1.956A3.748 3.748 0 0015 2.813a3.737 3.737 0 00-3.21 1.84zm3.68 3.785c-.528 0-1.018.136-1.458.356-.737-1.349-2.093-2.23-3.698-2.23a4.2 4.2 0 00-3.047 1.312 4.195 4.195 0 00-3.047-1.313 4.22 4.22 0 000 8.438h11.25a3.28 3.28 0 100-6.563z"
        />
      </svg>
    </StyledContainer>
  );
};

export default COEmissionsSVG;
